import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { NEVER, Observable, catchError, throwError } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { alertMessage } from 'src/app/shared/utility';
import { SweetAlertIcon } from 'sweetalert2';
import { Message } from 'src/app/models/api-response';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  iconSwal: SweetAlertIcon | undefined
  constructor(private auth: AuthenticationService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let token = this.auth.currentWalaiUserValue.token
    const loginPath = request.url.indexOf('login');
    if (loginPath == -1) {
      if (token) {
        const payload = parseJwt(token); // decode JWT payload part.
        if (Date.now() >= payload.exp * 1000) { // Check token exp.
          // redirect user to login page or auto refresh user's token and then replace the expired one and continue the process.
          console.log('expire1')
          this.auth.logout()
          return NEVER;
        }

        // If we have a token, we set it to the header
        request = request.clone({
          headers: request.headers.set('Authorization', `Bearer ${token}`)
        });
      }
    }
    return next.handle(request).pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            this.auth.logout()
          } else if (err.status === 400) {
            let error = err.error
            let msgs: Message = error.message
            this.iconSwal = 'warning'
            alertMessage(this.iconSwal, msgs)
          } else if (err.status === 404) {
            let msg: Message = {
              th: 'ไม่พบหน้าที่ต้องการ',
              en: 'Page not found'
            }
            this.iconSwal = 'warning'
            alertMessage(this.iconSwal, msg)
          } else {
            let msg: Message = {
              th: 'การเชื่อมต่อขัดข้อง',
              en: 'Unable to connect to services'
            }
            this.iconSwal = 'warning'
            alertMessage(this.iconSwal, msg)
          }
        }
        return NEVER;
      })
    );
  }
}
export function parseJwt(token: string): any {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map((c) => {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
}
